import Employee from './Employee'
import Batch from './Batch'
import SalesOffice from './SalesOffice'
import RequestType from './RequestType'
import RequestStatus from './RequestStatus'
import GeneralInfo from './GeneralInfo'
import DriverInfo from './DriverInfo'
import ContactInfo from './ContactInfo'
import PricingInfo from './PricingInfo'
import SalesAndDeliveryInfo from './SalesAndDeliveryInfo'
import BillingInfo from './BillingInfo'
import StatementInfo from './StatementInfo'
import AccountingInfo from './AccountingInfo'
import BillingDiscrepancyInfo from './BillingDiscrepancyInfo'
import SupportRequiredInfo from './SupportRequiredInfo'
import MICRInfo from './MICRInfo'
import PayerLinkageInfo from './PayerLinkageInfo'
import SuppressInfo from './SuppressInfo'
import CoolerInfo from './CoolerInfo'
import FountainInfo from './FountainInfo'
import VendorInfo from './VendorInfo'
import RemovalInfo from './RemovalInfo'
import OtherInfo from './OtherInfo'
import CustomerRequirementInfo from './CustomerRequirementInfo'
import FullServicePricingInfo from './FullServicePricingInfo'
import Address from './Address'
import RequestDay from './RequestDay'
import RequestEquipmentClass from './RequestEquipmentClass'
import RequestProductSize from './RequestProductSize'
import RequestPaymentOption from './RequestPaymentOption'
import RequestCustomer from './RequestCustomer'
import RequestAction from './RequestAction'
import RequestCompletionNumber from './RequestCompletionNumber'
import RequestInvoiceNumber from './RequestInvoiceNumber'
import PayerLinkageCustomer from './PayerLinkageCustomer'

import VendPackageLineItem from './VendPackageLineItem'

import CoolerLineItem from './CoolerLineItem'
import FountainLineItem from './FountainLineItem'
import VendorLineItem from './VendorLineItem'
import EquipmentLineItem from './EquipmentLineItem'
import PaperworkOnlyMoveLineItem from './PaperworkOnlyMoveLineItem'
import FullServicePricingLineItem from './FullServicePricingLineItem'
import Attachment from './Attachment'
import SalesOfficeApprover from './SalesOfficeApprover'

export class Request {
    ID?: number;
    SalesOfficeID: number;
    SalesOffice?: SalesOffice;
    EmployeeID: number;
    AssignedToEmployeeID?: number;
    RequestDate: Date;
    PhoneNumber: string;
    Employee?: Employee;
    AssignedToEmployee?: Employee;
    RequestTypeID: number;
    RequestType?: RequestType;
    RequestStatusID?: number;
    RequestStatus?: RequestStatus;
    DriverInfo?: DriverInfo;
    GeneralInfo?: GeneralInfo;
    ContactInfo?: ContactInfo;
    ContactInfos?: ContactInfo[];
    BillingInfo?: BillingInfo;
    StatementInfo?: StatementInfo;
    AccountingInfo?: AccountingInfo;
    BillingDiscrepancyInfo?: BillingDiscrepancyInfo;
    SupportRequiredInfo?: SupportRequiredInfo;
    MICRInfo?: MICRInfo;
    PayerLinkageInfo?: PayerLinkageInfo;
    SuppressInfo?: SuppressInfo;
    SalesAndDeliveryInfo?: SalesAndDeliveryInfo;
    PricingInfo?: PricingInfo;
    CoolerInfo?: CoolerInfo;
    FountainInfo?: FountainInfo;
    VendorInfo?: VendorInfo;
    RemovalInfo?: RemovalInfo;
    OtherInfo?: OtherInfo;
    CustomerRequirementInfo?: CustomerRequirementInfo;
    FullServicePricingInfo?: FullServicePricingInfo;
    Addresses?: Address[];
    CustomerAddress?: Address;
    BillingAddress?: Address;
    EquipmentAddress?: Address;
    VendPackageLineItems?: VendPackageLineItem[];
    CoolerLineItems?: CoolerLineItem[];
    FountainLineItems?: FountainLineItem[];
    VendorLineItems?: VendorLineItem[];
    EquipmentLineItems?: EquipmentLineItem[];
    PaperworkOnlyMoveLineItems?: PaperworkOnlyMoveLineItem[];
    FullServicePricingLineItems?: FullServicePricingLineItem[];
    RequestDays?: RequestDay[];
    RequestEquipmentClasses?: RequestEquipmentClass[];
    RequestProductSizes?: RequestProductSize[];
    RequestPaymentOptions?: RequestPaymentOption[];
    RequestInvoiceNumbers?: RequestInvoiceNumber[];
    RequestCustomers?: RequestCustomer[];
    PayerLinkageCustomers?: PayerLinkageCustomer[];
    Attachments?: Attachment[];
    RequestActions?: RequestAction[];
    NeedsReview?: boolean;
    AgingDays?: number;
    RequestCompletionNumbers?: RequestCompletionNumber[];
    CompletionNumbers?: string;
    BatchID?: number;
    Batch?: Batch;
    AppVersion?: string;
    BrowserName?: string;
    SalesOfficeApprovers?: SalesOfficeApprover[];
}

export default Request;